import { api } from '@forbiz/web-kit'
import type { ParseObituaryResponse } from '@forbiz/contracts'

/**
 * 부고 URL 파싱 클라이언트 (BIZ-79). URL을 보내면 서버가 받아와 파싱한 결과를 돌려준다.
 * 파싱·네트워크·화이트리스트는 서버가 처리 — 클라이언트는 이 seam만 본다.
 */
export const obituaryApi = {
  parse: (url: string) => api.post<ParseObituaryResponse>('/api/obituary/parse', { url }),
}
